import { render, staticRenderFns } from "./bheight.vue?vue&type=template&id=186686b8&scoped=true"
import script from "./bheight.vue?vue&type=script&lang=js"
export * from "./bheight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186686b8",
  null
  
)

export default component.exports